module.exports = __webpack_public_path__ + "img/polycyclicaromatichydrocarbons_icon.018cba8c.svg";